import { api } from '../api/client';

const PUSH_READY_KEY = 'admin_pwa_push_ready';

function b64uToUint8Array(value: string): Uint8Array {
  const padded = value + '='.repeat((4 - (value.length % 4)) % 4);
  const base64 = padded.replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
}

function toArrayBuffer(bytes: Uint8Array): ArrayBuffer {
  const out = new ArrayBuffer(bytes.byteLength);
  new Uint8Array(out).set(bytes);
  return out;
}

export function isPushSupported(): boolean {
  return (
    typeof window !== 'undefined' &&
    'serviceWorker' in navigator &&
    'PushManager' in window &&
    'Notification' in window
  );
}

export function isPushRememberedReady(): boolean {
  return window.localStorage.getItem(PUSH_READY_KEY) === '1';
}

export async function ensurePushSubscription(): Promise<'enabled' | 'denied' | 'unsupported' | 'not_configured'> {
  if (!isPushSupported()) return 'unsupported';
  const keyRes = await api.pushPublicKey();
  if (!keyRes.enabled || !keyRes.public_key) return 'not_configured';
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') return 'denied';
  const reg = await navigator.serviceWorker.ready;
  const existing = await reg.pushManager.getSubscription();
  const subscription = existing || await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: toArrayBuffer(b64uToUint8Array(keyRes.public_key)),
  });
  await api.pushSubscribe(subscription.toJSON());
  window.localStorage.setItem(PUSH_READY_KEY, '1');
  return 'enabled';
}

export async function syncExistingPushSubscription(): Promise<boolean> {
  if (!isPushSupported() || Notification.permission !== 'granted') return false;
  const reg = await navigator.serviceWorker.ready;
  const subscription = await reg.pushManager.getSubscription();
  if (!subscription) return false;
  await api.pushSubscribe(subscription.toJSON());
  window.localStorage.setItem(PUSH_READY_KEY, '1');
  return true;
}
